import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Button, { ButtonProps } from '../../button/Button';
import styles from './TableActionButton.module.scss';
import React, { ReactNode, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaEllipsisV } from 'react-icons/fa';

export interface TableActionButtonOption {
    label: string | ReactNode;
    active?: boolean;
    href?: string;
    onClick?: () => void;
}

type Props = {
    options: TableActionButtonOption[];
} & ButtonProps;

const TableActionButton = ({ options, ...props }: Props) => {
    // eslint-disable-next-line react/display-name
    const CustomToggle = React.forwardRef(({ ...p }, ref: any) => (
        <Button {...props} {...p} ref={ref} {...p} className={`${styles.button} ${(p as any).className ? (p as any).className : ''}`} />
    ));

    // eslint-disable-next-line react/display-name
    const CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }: any, ref: any) => {
            const [value, setValue] = useState('');

            return createPortal(
                <div
                    ref={ref}
                    style={style}
                    className={`${className} ${styles.dropdown}`}
                    aria-labelledby={labeledBy}
                >
                    {/* <Form.Control
                        autoFocus
                        className="mx-3 my-2 w-auto"
                        placeholder="Type to filter..."
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                    /> */}
                    <ul className={`list-unstyled ${styles.list}`}>
                        {React.Children.toArray(children).filter(
                            (child) =>
                                !value || (child as any).props.children.toLowerCase().startsWith(value),
                        )}
                    </ul>
                </div>,
                document.body,
            );
        },
    );

    return (
        <Dropdown drop='down' className={styles.dropdownContainer}>
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                <FaEllipsisV />
            </Dropdown.Toggle>

            <Dropdown.Menu as={CustomMenu}>
                {options.map((option, i) => (
                    option.href
                        ? <Dropdown.Item key={i} eventKey={i} active={option.active} as={Link} to={option.href} onClick={option.onClick}>{option.label}</Dropdown.Item>
                        : <Dropdown.Item key={i} eventKey={i} active={option.active} onClick={option.onClick}>{option.label}</Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
};

export default TableActionButton;
